export default "__VITE_ASSET__1svJFY2s__"